import { render, staticRenderFns } from "./RecordActions.vue?vue&type=template&id=3ef3222e&scoped=true&"
import script from "./RecordActions.vue?vue&type=script&lang=js&"
export * from "./RecordActions.vue?vue&type=script&lang=js&"
import style0 from "./RecordActions.vue?vue&type=style&index=0&id=3ef3222e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3222e",
  null
  
)

export default component.exports